import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, ExternalLink } from "lucide-react";
import { htmlSafe } from "../../lib/sanitize";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BASE = process.env.REACT_APP_BACKEND_URL;

const BlogPreview = () => {
  const { id } = useParams();
  const nav = useNavigate();
  const [post, setPost] = useState(null);

  useEffect(() => {
    axios.get(`${API}/cms/blog/${id}`).then((r) => setPost(r.data));
  }, [id]);

  if (!post) return <div className="p-8 text-slate-400">Loading preview…</div>;

  return (
    <div className="min-h-screen bg-white">
      <div className="sticky top-0 z-50 bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-between text-sm">
        <div className="text-amber-800 font-medium">
          <span className="inline-block w-2 h-2 bg-amber-500 rounded-full animate-pulse mr-2" />
          Preview mode · Status: <b>{post.status}</b>
        </div>
        <div className="flex gap-2">
          <button onClick={() => nav(`/app/website/blog/${id}`)} className="inline-flex items-center gap-1.5 text-amber-800 hover:bg-amber-100 px-3 py-1 rounded"><ArrowLeft size={14} /> Back to editor</button>
          {post.status === "published" && (
            <a href={`${BASE}/blog/${post.slug}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-amber-800 hover:bg-amber-100 px-3 py-1 rounded"><ExternalLink size={14} /> View live</a>
          )}
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-6 py-12">
        {post.cover_image_url && (
          <img src={post.cover_image_url.startsWith("/") ? `${BASE}${post.cover_image_url}` : post.cover_image_url} alt={post.title} className="w-full rounded-2xl border border-slate-200 mb-10" />
        )}
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 tracking-tight mb-4">{post.title}</h1>
        {post.excerpt && <p className="text-xl text-slate-600 leading-relaxed mb-6">{post.excerpt}</p>}
        <div className="flex items-center gap-3 text-sm text-slate-500 mb-10 pb-6 border-b border-slate-200">
          <span>By <b>{post.author_override_name || post.author_name || "—"}</b></span>
          {post.published_at && <><span>·</span><span>{new Date(post.published_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}</span></>}
          <span>·</span>
          <span>{post.views || 0} views</span>
        </div>
        <div className="prose prose-slate prose-lg max-w-none prose-headings:font-bold prose-a:text-prepify-600 prose-img:rounded-lg" dangerouslySetInnerHTML={htmlSafe(post.content_html || "")} />
      </article>
    </div>
  );
};

export default BlogPreview;
